import { Moment } from 'moment'
import { DraggableData } from 'react-draggable'

import { AppDispatch } from '../../../store'
import { setEventPosition } from '../../store/calendarSlice'
import { IEvent } from '../../types'

import { calculateColumnNumber } from './calculateColumnNumber'

export const eventDragCoordinateUpdate = (
  event: IEvent,
  eventDrag: DraggableData,
  columnWidth: number,
  eventPixelHeight: number,
  pixelsPerHour: number,
  selectedStartDate: Moment,
  dispatch: AppDispatch,
): void => {
  const newColumnNumber: number = calculateColumnNumber(
    eventDrag.lastX,
    columnWidth,
  )

  const newEventCoordinates = {
    eventNewY: eventDrag.lastY,
    eventNewColumnNumber: newColumnNumber,
    eventPixelHeight,
    pixelsPerHour,
    selectedStartDate,
  }

  dispatch(
    setEventPosition({
      eventPositionChange: {
        uuid: event.eventUuid,
        state: 'update',
        eventData: event,
        eventCoordinates: newEventCoordinates,
      },
    }),
  )
}
